// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1KbQr","col":"Table_col__mYN0G","fulfillmentStatus":"Table_fulfillmentStatus__30J9Q","emailCol":"Table_emailCol__2JXnU"};